import { BaseResource } from 'utils/ApiUtils';

export default class WorkforceLabor extends BaseResource {
  static columns = [
    {
      title: "Inspection #",
      field: "inspectionNumber"
    },
    { title: "Inspector", field: "inspectorName" },
    {
      title: "Occurrence Date",
      field: "occurrenceDate",
      type: "date",
      defaultSort: "desc"
    },
    {
      title: "Contractor Service",
      field: "Description_ServiceType"
    },
    {
      title: "Contractor Name",
      field: "contractorName"
    },
    {
      title: "Labor Type",
      field: "Description_LaborType"
    },
    {
      title: "Personnel No",
      field: "personnelCount"
    },
    {
      title: "Labor Sub Type",
      field: "Description_LaborSubType"
    },
    {
      title: "Skill Type",
      field: "Description_SkillType"
    },
    {
      title: "Staff Present",
      field: "staffPresent",
      type: "boolean"
    }
  ];

  static attributes = WorkforceLabor.columns.map((r) => r.field);

  static expand = [
    {
      ContractorService: {
        expand: {
          ServiceType: {
            select: ["Description"]
          },
          ContractorProject: {
            expand: {
              ContractorNavigation: {
                select: ["Description"]
              }
            }
          }
        }
      }
    },
    {
      Laborer: {
        select: ["LaborerId"]
      }
    },
    {
      LaborType: {
        select: ["Description"]
      }
    },
    {
      LaborSubType: {
        select: ["Description"]
      }
    },
    {
      SkillType: {
        select: ["Description"]
      }
    },
    {
      "Ihwi": {
        expand: [
          {
            "Inspection": {
              select: ["InspectionNumber"]
            }
          },
          {
            "Inspection": {
              expand:
              {
                "Rassignment": {
                  expand:
                  {
                    "SystemUser": { "select": ["Name"] }
                  }
                }
              }
            }
          }
        ]
      }
    }
  ];

  constructor(args) {
    super(args, WorkforceLabor.attributes);
  }
}
